import { render, staticRenderFns } from "./UploadAttachment.vue?vue&type=template&id=1863b764&scoped=true&"
import script from "./UploadAttachment.vue?vue&type=script&lang=js&"
export * from "./UploadAttachment.vue?vue&type=script&lang=js&"
import style0 from "./UploadAttachment.vue?vue&type=style&index=0&id=1863b764&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1863b764",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
